var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPoint1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.83191 0 0 5.65637 0 12.6092C0 17.6644 6.50226 25.5804 10.3797 29.8507C10.7091 30.2122 11.1129 30.5015 11.5644 30.6995C12.016 30.8976 12.5052 31 13 31C13.4948 31 13.984 30.8976 14.4356 30.6995C14.8871 30.5015 15.2909 30.2122 15.6203 29.8507C19.4966 25.5827 26 17.6655 26 12.6092C26 5.65637 20.1681 0 13 0ZM13 7.14326C16.1166 7.14326 18.6522 9.59557 18.6522 12.6092C18.6522 15.6228 16.1166 18.0751 13 18.0751C9.88339 18.0751 7.34783 15.6228 7.34783 12.6092C7.34783 9.59557 9.88339 7.14326 13 7.14326Z",
    fill: "#C61E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPoint1);
export default __webpack_public_path__ + "static/media/mapPoint1.5c018ab583202577a8bd2db707c990dd.svg";
export { ForwardRef as ReactComponent };